

























































































































































































































































































import { Component, Prop } from "vue-property-decorator";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import { NewOrganizationUser, OrganizationUser, UpdateOrganizationUser } from "@/api/lab-base-api-client";
import CTooltip from "@/components/CTooltip.vue";
import TooltipModule from "@/store/tooltip";
import { sortCreatedAt } from "@/utils/Util";
import { ValidationObserver } from "vee-validate";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class OrganizationUserList extends CheckOrganizationAdminLogin {
  // 削除済みユーザー表示スイッチ初期値
  private isIncludeDelete = false;

  // 所属団体uuid
  @Prop({ type: String, required: true })
  organizationUuid!: string;

  // tableの検索初期値
  private search = "";

  // tableのheader設定配列
  private headers = [
    {
      text: "name",
      align: "start",
      sortable: false,
      value: "name",
    },
    {
      text: "mail address",
      value: "email",
    },
    { text: "", value: "actions", sortable: false },
  ];

  // 削除・編集の団体所属ユーザーのuuid
  private uuid = "";

  private confirmEmail = "";

  // tableのデータ配列
  private listItems: OrganizationUser[] = [];

  private isCreateDialog = false;

  private createItems: NewOrganizationUser = {
    name: "",
    email: "",
    confirmEmail: "",
    organizationUuid: "",
    detail: { fullName: "" },
  };

  private defaultCreateItems: NewOrganizationUser = {
    name: "",
    email: "",
    confirmEmail: "",
    organizationUuid: "",
    detail: { fullName: "" },
  };

  private isEditDialog = false;

  private editItems: UpdateOrganizationUser = { name: "", email: "" };

  private defaultEditItems: UpdateOrganizationUser = { name: "", email: "" };

  private dialogDelete = false;

  // 削除ダイアログの確認checkboxの初期値
  private checkbox = false;

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // ページ読み込み時に実行
  private async mounted() {
    this.fetchList();
  }

  // 削除済みユーザー表示スイッチ切り替え時に実行
  private async onIncludeDelete() {
    if (this.isIncludeDelete === true) {
      const organizationRes = await OrganizationUsersApi.instance.getOrganizationUsers(
        undefined,
        undefined,
        undefined,
        undefined,
        true,
        this.organizationUuid
      );
      if (organizationRes.data.data.items) {
        this.listItems = organizationRes.data.data.items;
      }
      this.listItems.sort(sortCreatedAt);
    } else {
      this.fetchList();
    }
  }

  // 団体所属ユーザーの取得一覧の取得
  private async fetchList() {
    const organizationRes = await OrganizationUsersApi.instance.getOrganizationUsers(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      this.organizationUuid
    );
    if (organizationRes.data.data.items) {
      this.listItems = organizationRes.data.data.items;
    }
    this.listItems.sort(sortCreatedAt);
  }

  // 「団体登録」クリックで実行
  private onNewItem() {
    this.isCreateDialog = true;
  }

  // 登録ダイアログ「save」で実行、団体ユーザーを登録
  private async createSubmit() {
    this.createItems.organizationUuid = this.organizationUuid;
    this.createItems.detail.fullName = this.createItems.name;
    try {
      const organizationUserRes = await OrganizationUsersApi.instance.createOrganizationUser(this.createItems);
      if (!organizationUserRes?.data?.data?.organizationUser) {
        return;
      }
      this.closeCreate();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.isIncludeDelete = false;
    this.fetchList();
  }

  // 登録ダイアログを閉じる
  private closeCreate() {
    this.isCreateDialog = false;
    this.createItems = { ...this.defaultCreateItems };
    TooltipModule.commitIsShow(false);
    this.resetValidation();
  }

  // 編集アイコンclickで実行
  private async onEditItem(organizationUser: OrganizationUser) {
    this.uuid = organizationUser.uuid;
    this.editItems.name = organizationUser.name;
    this.editItems.email = organizationUser.email;

    this.isEditDialog = true;
  }

  // 編集ダイアログの「save」クリックで実行
  private async saveEdit() {
    try {
      await OrganizationUsersApi.instance.updateOrganizationUserByUuid(this.uuid, this.editItems);
      this.closeEdit();
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.fetchList();
  }

  // 編集ダイアログを閉じる
  private closeEdit() {
    this.isEditDialog = false;
    this.editItems = { ...this.defaultEditItems };
    this.uuid = "";
    this.confirmEmail = "";
    this.resetValidation();
  }

  // 削除アイコンclickで実行
  private async onDeleteItem(uuid: string) {
    this.dialogDelete = true;
    this.uuid = uuid;
  }

  // 削除ダイアログの「ok」クリックで実行
  private async deleteItem() {
    try {
      await OrganizationUsersApi.instance.deleteOrganizationUserByUuid(this.uuid);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.closeDelete();
    await this.fetchList();
  }

  // 削除ダイアログを閉じる
  private closeDelete() {
    this.dialogDelete = false;
    this.uuid = "";
    this.checkbox = false;
  }

  // 行のクリックで実行
  private clickRow(item: { uuid: string }) {
    if (this.isIncludeDelete) {
      return;
    }
    this.$router.push({
      name: this.$route.name === "OUserList" ? "OUserDetail" : "MUserListDetail",
      params: { uuid: item.uuid },
    });
  }

  // バリデーションリセット
  private resetValidation() {
    if (!this.$refs.observer) {
      return;
    }
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }
}
